import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Alert, AlertDescription } from "../components/ui/alert";
import { useAuth } from "../context/AuthContext";
import { Loader2, Lock, ShieldCheck } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (user) navigate(location.state?.from || "/consulta", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const submeter = async (e) => {
    e.preventDefault();
    setErro("");
    if (!email.trim() || !senha) {
      setErro("Informe e-mail e senha.");
      return;
    }
    setEnviando(true);
    const r = await login(email.trim(), senha);
    setEnviando(false);
    if (!r.ok) setErro(r.erro);
    else navigate(location.state?.from || "/consulta", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto grid min-h-screen max-w-6xl items-center gap-10 px-4 py-10 lg:grid-cols-2 lg:gap-16">
        {/* marca / promessa */}
        <div className="order-2 lg:order-1">
          <img
            src="/brand/logo-skymaster.png"
            alt="SKYMASTER Condutores Elétricos"
            className="h-40 w-auto lg:h-72"
          />

          <h1 className="mt-7 font-display text-3xl font-bold leading-[1.12] tracking-tight text-slate-900 sm:text-4xl">
            O preço certo, em segundos.
          </h1>
          <p className="mt-3 max-w-lg text-[15px] leading-relaxed text-slate-600">
            Portal de consulta para representantes comerciais do Grupo Sky Master.
          </p>
        </div>

        {/* card de login */}
        <div className="order-1 lg:order-2">
          <div className="mx-auto w-full max-w-md overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[var(--shadow-md)]">
            <div className="flex h-1.5 w-full">
              <span className="h-full flex-1 bg-[#1B315E]" />
              <span className="h-full w-1/3 bg-[#EC2128]" />
            </div>
            <div className="p-6 sm:p-8">
            <img
              src="/brand/logo-skymaster-horizontal.png"
              alt="SKYMASTER"
              className="mb-5 h-10 w-auto lg:hidden"
            />
            <h2 className="font-display text-xl font-bold text-slate-900">Entrar no portal</h2>
            <p className="mt-1 text-[13px] text-slate-500">
              Use o e-mail e a senha fornecidos pelo administrador.
            </p>

            <form onSubmit={submeter} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">E-mail</Label>
                <Input
                  id="email"
                  type="email"
                  autoComplete="email"
                  placeholder="seu.nome@sky.com.br"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="h-11"
                  data-testid="login-email-input"
                />
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="senha">Senha</Label>
                <Input
                  id="senha"
                  type="password"
                  autoComplete="current-password"
                  placeholder="••••••••"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  className="h-11"
                  data-testid="login-password-input"
                />
              </div>

              {erro && (
                <Alert variant="destructive" data-testid="login-error-message">
                  <AlertDescription>{erro}</AlertDescription>
                </Alert>
              )}

              <Button
                type="submit"
                className="h-11 w-full text-[15px]"
                disabled={enviando}
                data-testid="login-submit-button"
              >
                {enviando ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Entrando…
                  </>
                ) : (
                  <>
                    <Lock className="mr-2 h-4 w-4" /> Entrar
                  </>
                )}
              </Button>
            </form>

            <div className="mt-5 flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2.5 text-[11.5px] text-slate-600">
              <ShieldCheck className="h-4 w-4 shrink-0 text-primary" />
              Ambiente seguro. Acesso criado e controlado pelo administrador da SKYMASTER.
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
